// Project Imports
import NeedTypeEnum from "constants/NeedTypeEnum"
import checkIsValueEmpty from "utils/checkIsValueEmpty"
import ChooseNeedsFormController from "./controller"
import StorageKeys from "constants/StorageKeys"


export function chooseNeedFieldValidation(formName,fieldName) {
  return ({ field, form }) => {

    let currentFormDisableState = form.$(formName).disabled
    let currentFieldValue = field.value
    let showProductDropdown = localStorage.getItem(StorageKeys.SHOW_PRODUCT_DROPDOWN) === "true" ? true : false;

    if (!showProductDropdown && fieldName === 'products_list') {
      return [true, ""]
    }

    if (!currentFormDisableState && checkIsValueEmpty(currentFieldValue)) {
      return [false, "This field is mandatory"]
    } else {
      return [true, ""]
    }
  }
}

export function validateTargetAmount(formName) {
  return ({ field, form }) => {

    let currentFormDisabled = form.$(formName).disabled

    if (currentFormDisabled) {
      return [true, ""]
    }

    let isFieldVisible = field.type === 'text'
    let fieldValue = field.value

    if (isFieldVisible && checkIsValueEmpty(fieldValue)) {
      return [false, "This field is mandatory"]
    }

    return [true, ""]

  }
}

export function validateTargetAmountValue(formName) {
  return ({ field, form }) => {
    
    let label = form.$(formName).$("target_amount_dropdown").value.label
    let amount_label =   form.$(formName).$("target_amount_dropdown").value.amount_label
    let targetAmountDropdownType = form.$(formName).$("target_amount_dropdown").type

    let isFieldVisible = field.type === 'text'
    let fieldValue = Number(field.value)

    if (isFieldVisible && checkIsValueEmpty(field.value)) {
      return [false, "This field is mandatory"]
    }

    if (targetAmountDropdownType === 'text' && formName != NeedTypeEnum.PROTECTION_FOR_MY_FAMILY) {
      
      switch (label) {
        case "30000":
          if (fieldValue != 30000) {
            return [false, `Enter the value  ${amount_label}`]
          }
          break;

        case "30000 to 1 Lac":
          if (fieldValue < 30000 || fieldValue > 100000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "1 Lac to 2 Lacs":
          if (fieldValue < 100000 || fieldValue > 200000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "2 Lacs to 4 Lacs":
          if (fieldValue < 200000 || fieldValue > 400000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "Above 4 Lacs":

          if (fieldValue < 400000) {
            return [false, `Enter the value ${amount_label.replace("Above", "above")}`]
          }
          break;


        case "15 Lacs":
          if (fieldValue != 1500000) {
            return [false, `Enter the value  ${amount_label}`]
          }
          break;

        case "15 to 30 Lacs":
          if (fieldValue < 1500000 || fieldValue > 3000000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "30 to 60 Lacs":
          if (fieldValue < 3000000 || fieldValue > 6000000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "60 Lacs to 1 Crore":
          if (fieldValue < 6000000 || fieldValue > 10000000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "Above 1 Crore":
          if (fieldValue < 10000000) {
            return [false, `Enter the value ${amount_label.replace("Above", "above")}`]
          }
          break;

        default:

          break;
      }
    }else if(targetAmountDropdownType === 'text' && formName === NeedTypeEnum.PROTECTION_FOR_MY_FAMILY){
      switch (label) {
        case "25 Lacs":
          if (fieldValue != 2500000) {
            return [false, `Enter the value  ${amount_label}`]
          }
          break;

        case "50 Lacs to 75 Lacs":
          if (fieldValue < 5000000 || fieldValue > 7500000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "75 Lacs to 1 Cr":
          if (fieldValue < 7500000 || fieldValue > 10000000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "1 Cr to 2 Cr":
          if (fieldValue < 10000000 || fieldValue > 20000000) {
            return [false, `Enter the value between ${amount_label}`]
          }
          break;

        case "Above 2 Cr":

          if (fieldValue < 20000000) {
            return [false, `Enter the value ${amount_label.replace("Above", "above")}`]
          }
          break;

        default:

          break;
      }
    }

    return [true, ""]

  }
}

export function checkIfOneNeedIsSelected({ form }) {
  let familyProtection = form.$("protection_for_my_family").disabled
  let healthProtection = form.$("protection_for_my_health").disabled
  let moneyNeed = form.$("grow_my_money").disabled
  let childrenNeed = form.$("save_for_children").disabled
  let retirementNeed = form.$("save_for_retirement").disabled

  if (!familyProtection || !healthProtection || !moneyNeed || !childrenNeed || !retirementNeed) {
    return [true, ""]
  } else {
    return [false, "Please select atleast one need"]
  }
}

export function validatePinCode({ field, form, validator }) {
  let isProtectionSelected = form.$("protection_for_my_family").disabled
  let currentFieldValue = field.value
  if (!isProtectionSelected && checkIsValueEmpty(currentFieldValue)) {
    return [false, "This field is mandatory"]
  }

  return [true, ""]
}

